import {Component, OnDestroy, OnInit} from '@angular/core';
import {Unit} from '../../../../types/data.types';
import {DirectoryService} from '../../../../services/directory.service';
import {ApiClientService} from '../../../../services/api-client.service';
import {AbstractDetailedView} from '../abstract-detailed-view';

declare const toastr;
declare const moment;

@Component({
    selector: 'unit-view',
    templateUrl: './unit-view.component.html'
})

export class UnitViewComponent extends AbstractDetailedView implements OnInit, OnDestroy {
    title = 'Unit';
    buzzFieldsCopy = [];
    keyCodeCopy = [];
    keyFobCopy = [];
    showInstructionsHistory = false;

    constructor(
        public directoryService: DirectoryService,
        public api: ApiClientService
    ) {
        super(directoryService, api);
        this.directoryService.residentInstructionUpdated.subscribe(instruction => {
            const index = this.data.instructions.findIndex((i => instruction.id == i.id));
            instruction.user = this.data.instructions[index].user;
            this.data.instructions[index] = instruction;
        });
    }

    addNew(itemName) {
        this.data[itemName + 'Fields'].push({
            user: null,
            fieldValue: ''
        });
    }

    applyArrayFieldChanges(form, formField) {
        let isValid = true;
        let data = {};
        data[formField] = [];
        for(let i = 0; i < this.data[formField].length; i++) {
            if(!form.controls[formField + 'FieldValue' + i].value)
                isValid = false;
            data[formField].push({
                user: form.controls[formField + 'User' + i].value || form.controls[formField + 'User' + i].value === null ? form.controls[formField + 'User' + i].value : undefined,
                fieldValue: form.controls[formField + 'FieldValue' + i].value
            });
        }
        if(isValid) {
            this.setEditModeForAll(false);
            this.patch(form.value.id, data);
        } else
            toastr.warning('All text fields must be filled');
    }

    setEditModeFor(item, fieldName: string, state: boolean) {
        if(fieldName == 'buzz' || fieldName == 'keyCode' || fieldName == 'keyFob') {
            if(state)
                this[fieldName + 'Copy'] = JSON.parse(JSON.stringify(this.data[fieldName + 'Fields']));

            if(state && this.data[fieldName + 'Fields'].length < 1) {
                this.data[fieldName + 'Fields'] = [''];
            }else if(!state && this.data[fieldName + 'Fields'].length == 1 && this.data[fieldName + 'Fields'][0] == '')
                this.data[fieldName + 'Fields'] = [];
        }
        super.setEditModeFor(item, fieldName, state);
    }

    cancelArrayFieldsChanges(item, fieldName: string, state: boolean){
        this.data[fieldName + 'Fields'] = JSON.parse(JSON.stringify(this[fieldName + 'Copy']));
        this.setEditModeFor(item, fieldName, state);
    }

    getUserNameById(id) {
        const suiteUser = this.data.suiteUser.find(su => su.user.id == id);
        return suiteUser ? suiteUser.user.fullName : '';
    }

    removeItem(index, fieldName, form) {
        this.data[fieldName + 'Fields'].splice(index, 1);
        let data = {};
        data[fieldName + 'Fields'] = this.data[fieldName + 'Fields'].map(f => ({
            user: f.user,
            fieldValue: f.fieldValue
        }));
        this.setEditModeForAll(false);
        this.patch(form.value.id, data);
    }

    numberOfCurrentInstructions() {
        return this.data.instructions.filter(i => i.status == 'current').length;
    }

    getInstructions() {
        if(!this.showInstructionsHistory)
            return this.data.instructions.filter(i => i.status == 'current');
        else
            return this.data.instructions;
    }

    actionButtonIsNotAvailable() {
        return !this.data.isCanDelete;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/directory/detailed-view/unit-view/unit-view.component.ts